// extracted by mini-css-extract-plugin
module.exports = {"question_button":"ml_question_button__22FAf"};